const getPinterestProductId = (product, variant) => {
  const selectedVariant = variant
  const productId = product.title.toLowerCase().replace(" ", "-")

  let pinterestProductId
  let selectedVariantName = selectedVariant.title
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+/g, "-")

  if (selectedVariantName.endsWith("-")) {
    selectedVariantName = selectedVariantName.slice(0, -1)
  }

  pinterestProductId = `${productId}-${selectedVariantName}`

  return pinterestProductId
}

export { getPinterestProductId }
